import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'redundant-modal',
  templateUrl: 'redundant-modal.component.html',
  styleUrls: ['../../general.scss']
})
export class RedundantModalComponent {
    public oldColumnName: string;
    public newColumnName: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<RedundantModalComponent>) {
        this.oldColumnName = data.oldColumnName;
        this.newColumnName = data.newColumnName;
    }

    public switch() {
        this.dialogRef.close(true);
    }
}
